__turbopack_context__.v({
  "arrowButton": "ListingCardGallery-module__GUY7UG__arrowButton",
  "carousel": "ListingCardGallery-module__GUY7UG__carousel",
  "dot": "ListingCardGallery-module__GUY7UG__dot",
  "dotActive": "ListingCardGallery-module__GUY7UG__dotActive",
  "gallery": "ListingCardGallery-module__GUY7UG__gallery",
  "gradientOverlay": "ListingCardGallery-module__GUY7UG__gradientOverlay",
  "overlay": "ListingCardGallery-module__GUY7UG__overlay",
  "overlayBottom": "ListingCardGallery-module__GUY7UG__overlayBottom",
  "overlayMiddle": "ListingCardGallery-module__GUY7UG__overlayMiddle",
  "overlayTop": "ListingCardGallery-module__GUY7UG__overlayTop",
  "overlayTopLeft": "ListingCardGallery-module__GUY7UG__overlayTopLeft",
  "overlayTopRight": "ListingCardGallery-module__GUY7UG__overlayTopRight",
  "scrollTrack": "ListingCardGallery-module__GUY7UG__scrollTrack",
  "singleImage": "ListingCardGallery-module__GUY7UG__singleImage",
  "slide": "ListingCardGallery-module__GUY7UG__slide",
  "slideImage": "ListingCardGallery-module__GUY7UG__slideImage",
});
